/**
 * Build/serve-time local API base URL.
 * Written by `scripts/serve-with-local-api.js` (--api-port / --api-url).
 * Keep `null` in git; non-null values are session-local only.
 * Also requires `dev.useLocalApiUrlOverride` in context.local.json (see dev-context.ts).
 */
export const LOCAL_API_URL_OVERRIDE: string | null = null;
